import FdContainer from "./_container.vue";
import { pluginify } from "./../../util";
export default pluginify(FdContainer);
export { default as Container } from "./_container.vue";
